var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerInfrastructure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 360",
    width: 840,
    height: 360,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#f39f9f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 840,
    height: 360,
    fill: "#133051"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Poppins, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 500,
    fill: "#ffffff",
    textAnchor: "middle",
    dominantBaseline: "central"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 148,
    width: 130,
    height: 64,
    rx: 32,
    fill: "rgba(162, 222, 235, 0.08)",
    stroke: "#a2deeb",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 180
  }, "Internet"), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 136,
    width: 200,
    height: 88,
    rx: 12,
    fill: "rgba(243, 159, 159, 0.1)",
    stroke: "#f39f9f",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 166
  }, "Reverse Proxy"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 196,
    fill: "#f39f9f"
  }, "(TLS)"), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 40,
    width: 400,
    height: 280,
    rx: 16,
    fill: "none",
    stroke: "rgba(162, 222, 235, 0.35)",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 60,
    width: 200,
    height: 64,
    rx: 10,
    fill: "rgba(162, 222, 235, 0.08)",
    stroke: "#a2deeb",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 545,
    y: 92
  }, "Git Hosting"), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 148,
    width: 200,
    height: 64,
    rx: 10,
    fill: "rgba(162, 222, 235, 0.08)",
    stroke: "#a2deeb",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 545,
    y: 180
  }, "Cloud Storage"), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 236,
    width: 200,
    height: 64,
    rx: 10,
    fill: "rgba(162, 222, 235, 0.08)",
    stroke: "#a2deeb",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 545,
    y: 268
  }, "Web App"), /*#__PURE__*/React.createElement("path", {
    d: "M680 244 V292 A60 12 0 0 0 800 292 V244",
    fill: "rgba(162, 222, 235, 0.08)",
    stroke: "#a2deeb",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 740,
    cy: 244,
    rx: 60,
    ry: 12,
    fill: "#1b3d5e",
    stroke: "#a2deeb",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 740,
    y: 274,
    fontSize: 22
  }, "Database"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#f39f9f",
    strokeWidth: 2.5,
    markerEnd: "url(#arrow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 180 H186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 180 H441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 180 H410 V92 H441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 180 H410 V268 H441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 268 H676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerInfrastructure);
export default __webpack_public_path__ + "static/media/server-infrastructure.adc07d508b537b969a0814e22b4b1591.svg";
export { ForwardRef as ReactComponent };